const pageNameKey = "nodesCounterSelector";

export const nodesCounterSelectorEn = {
  [pageNameKey]: {
    selectAll: "Select all",
    deselectAll: "Deselect all",
    selectAllFiltered: "Select all filtered",
    deselectAllFiltered: "Deselect all filtered",
    noItemsSelected: "No items selected",
    selectedItems: "selected items",
  },
};

export const nodesCounterSelectorPtBr = {
  [pageNameKey]: {
    selectAll: "Selecionar tudo",
    deselectAll: "Desmarcar tudo",
    selectAllFiltered: "Selecionar todos os filtrados",
    deselectAllFiltered: "Desmarcar todos os filtrados",
    noItemsSelected: "Nenhum item selecionado",
    selectedItems: "itens selecionados",
  },
};

export const nodesCounterSelectorDe = {
  [pageNameKey]: {
    selectAll: "Alle auswählen",
    deselectAll: "Alle abwählen",
    selectAllFiltered: "Alle gefilterten auswählen",
    deselectAllFiltered: "Alle gefilterten abwählen",
    noItemsSelected: "Keine Elemente ausgewählt",
    selectedItems: "ausgewählte Elemente",
  },
};

export const nodesCounterSelectorZhHans = {
  [pageNameKey]: {
    selectAll: "全选",
    deselectAll: "取消全选",
    selectAllFiltered: "选择所有过滤项",
    deselectAllFiltered: "取消选择所有过滤项",
    noItemsSelected: "未选择任何项目",
    selectedItems: "已选择项目",
  },
};

export const nodesCounterSelectorIt = {
  [pageNameKey]: {
    selectAll: "Seleziona tutto",
    deselectAll: "Deseleziona tutto",
    selectAllFiltered: "Seleziona tutti i nodi filtrati",
    deselectAllFiltered: "Deseleziona tutti i nodi filtrati",
    noItemsSelected: "Nessun nodo selezionato",
    selectedItems: "Nodi selezionati",
  },
};

export const nodesCounterSelectorEs = {
  [pageNameKey]: {
    selectAll: "Seleccionar todo",
    deselectAll: "Deseleccionar todo",
    selectAllFiltered: "Seleccionar todos los filtrados",
    deselectAllFiltered: "Deseleccionar todos los filtrados",
    noItemsSelected: "No hay elementos seleccionados",
    selectedItems: "elementos seleccionados",
  },
};

export const nodesCounterSelectorNl = {
  [pageNameKey]: {
    deselectAll: "Alles deselecteren",
    deselectAllFiltered: "Alle gefilterde deselecteren",
    noItemsSelected: "Geen items geselecteerd",
    selectAll: "Alles selecteren",
    selectAllFiltered: "Alle gefilterde selecteren",
    selectedItems: "geselecteerde items",
  },
};

export const nodesCounterSelectorTr = {
  [pageNameKey]: {
    deselectAll: "Tümünün seçimini kaldır",
    deselectAllFiltered: "Filtrelenenlerin tümünün seçimini kaldır",
    noItemsSelected: "Hiçbir öğe seçilmedi",
    selectAll: "Tümünü seç",
    selectAllFiltered: "Filtrelenenlerin tümünü seç",
    selectedItems: "seçili öğeler",
  },
};
